import { Clock3, MessageCircle, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import caregiverImage from "../assets/dagbesteding-samen.jpg";
import { Button } from "./ui/button";

export const CAREGIVER_NEEDS = [
  {
    icon: ShieldCheck,
    title: "Vertrouwen",
    description: "Weten dat taal, gewoonten en vertrouwde omgang onderdeel zijn van de aandacht voor uw naaste."
  },
  {
    icon: Clock3,
    title: "Adempauze",
    description: "Tijd voor rust, werk, gezin of herstel, terwijl uw naaste een betekenisvolle dag heeft."
  },
  {
    icon: MessageCircle,
    title: "Meedenken",
    description: "Uw ervaring helpt om de behoefte in Winterswijk en omgeving zorgvuldig in beeld te brengen."
  }
];

const CaregiverOverview = ({ content }) => {
  const image = content?.caregiver_image_url || caregiverImage;
  const needs = [
    { icon: ShieldCheck, title: content?.caregiver_need_1_title || CAREGIVER_NEEDS[0].title, description: content?.caregiver_need_1_text || CAREGIVER_NEEDS[0].description },
    { icon: Clock3, title: content?.caregiver_need_2_title || CAREGIVER_NEEDS[1].title, description: content?.caregiver_need_2_text || CAREGIVER_NEEDS[1].description },
    { icon: MessageCircle, title: content?.caregiver_need_3_title || CAREGIVER_NEEDS[2].title, description: content?.caregiver_need_3_text || CAREGIVER_NEEDS[2].description }
  ];
  return (
  <>
    <section className="bg-white py-12 md:py-16 lg:py-20">
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-4 sm:px-6 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] lg:gap-16 lg:px-8">
        <figure className="overflow-hidden rounded-md bg-secondary lg:order-first">
          <img
            src={image}
            alt={content?.caregiver_image_alt || "Ouderen die in een rustige omgeving persoonlijke aandacht krijgen"}
            className="aspect-[4/3] h-full w-full object-cover object-center"
            loading="eager"
            decoding="async"
          />
          <figcaption className="sr-only">Persoonlijke aandacht geeft mantelzorgers vertrouwen en ruimte.</figcaption>
        </figure>

        <div className="max-w-xl">
          <p className="section-label">{content?.caregiver_label || "Voor mantelzorgers"}</p>
          <h1 className="section-title">{content?.caregiver_title || "Ruimte om op adem te komen"}</h1>
          <div className="mt-5 space-y-4 text-lg leading-relaxed text-muted-foreground">
            <p>{content?.caregiver_intro_1 || "Veel families dragen langdurig zorg voor een ouder of naaste. Dat vraagt liefde en geduld, maar ook steeds meer praktische en emotionele kracht."}</p>
            <p>{content?.caregiver_intro_2 || "De dagbesteding biedt tijdelijke ontlasting, met het vertrouwen dat uw naaste op een plek is waar achtergrond, gewoonten en persoonlijke behoeften serieus worden genomen."}</p>
          </div>
        </div>
      </div>
    </section>

    <section className="bg-secondary/40 py-12 md:py-16" aria-labelledby="caregiver-needs">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="section-label">{content?.caregiver_needs_label || "Wat dit kan betekenen"}</p>
          <h2 id="caregiver-needs" className="mt-3 font-heading text-3xl font-bold sm:text-4xl">{content?.caregiver_needs_title || "Zorgen hoeft niet zonder ondersteuning"}</h2>
        </div>
        <div className="mt-8 grid border-y border-border md:grid-cols-3 md:divide-x md:divide-border">
          {needs.map(({ icon: Icon, title, description }) => (
            <article key={title} className="border-b border-border py-7 last:border-b-0 md:border-b-0 md:px-7 md:first:pl-0 md:last:pr-0">
              <Icon className="h-7 w-7 text-accent" aria-hidden="true" />
              <h3 className="mt-4 font-heading text-xl font-semibold">{title}</h3>
              <p className="mt-3 leading-relaxed text-muted-foreground">{description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>

    <section className="bg-primary py-10 text-primary-foreground" aria-labelledby="caregiver-contact">
      <div className="mx-auto flex max-w-7xl flex-col gap-6 px-4 sm:px-6 md:flex-row md:items-center md:justify-between lg:px-8">
        <div className="max-w-3xl">
          <h2 id="caregiver-contact" className="font-heading text-2xl font-bold sm:text-3xl">{content?.caregiver_cta_title || "Wilt u uw behoefte of belangstelling delen?"}</h2>
          <p className="mt-2 leading-relaxed text-white/75">{content?.caregiver_cta_text || "Dit is nog geen formele aanmelding. Uw reactie helpt om de dagbesteding zorgvuldig op te bouwen."}</p>
        </div>
        <Button asChild className="shrink-0 rounded-md bg-accent hover:bg-accent/90">
          <Link to="/contact">Neem contact op</Link>
        </Button>
      </div>
    </section>
  </>
  );
};

export default CaregiverOverview;
